window.addEventListener('load', () => {
  const backLink = document.querySelector('.back-button');

  let formValues = {};

  const formValuesFromSessionStorage = sessionStorage ? sessionStorage.getItem('formValues') : null;

  if (formValuesFromSessionStorage) {
    formValues = JSON.parse(formValuesFromSessionStorage);

    if (backLink) {
      backLink.setAttribute(
        'href',
        `/cards?orderId=${formValues.orderId}&amount=${formValues.amount}`,
      );
    }
  }
});
